import React from 'react'
import PaperPage from 'src/components/organisms/whitepapers/PaperPage'
import thumbnail from 'src/images/whitepapers/commmune-overseascase.png'

const paperInfo = {
  paperName: '海外事例に学ぶ顧客接点のこれから',
  thumbnail,
  feature1: '生活・ビジネスにおける急激なオンラインシフトの実態',
  feature2: 'ワクチン接種が進む国の働き方',
  feature3: 'ワクチン接種が進む国のビジネス（BtoB、BtoC）',
  description:
    '急激なオンライン化が進み、顧客接点の構築に頭を悩ませている担当者も多いのではないでしょうか。ワクチン接種が進んでいる国の事例をもとに、顧客接点のあるべき姿を解説します。',
  formSrc: 'https://go.commmune.jp/l/915341/2022-03-09/dwl5t',
  type: 'pardot' // TODO: HubSpotからPardotに移行したらこのタグ付けが不要になるので削除する
}

const WhitePaperPage = () => {
  return <PaperPage {...paperInfo} />
}

export default WhitePaperPage
